import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";

import ReactSelect from "react-select";
import styled from "styled-components";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from "react-select";
import { tokenHelper } from "../../../stores/helpers";
import { reactSelectStyling } from "../../../Components/Common/Forms/FormikInputHelper";

const Section = ({
  selectedSiteIds,
  setSelectedSiteIds,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  timezone,
  setTimezone,
  siteList,
  getDailyReport,
}) => {
  const [userName, setUserName] = useState("user");
  
  // Convert selectedSiteIds to ReactSelect format
  const selectedSiteOptions = siteList.filter(site => 
    selectedSiteIds.includes(site.value)
  );
  
  useEffect(() => {
    const info = async () => {
      const user = await tokenHelper.getUser();
      setUserName(user.name);
    };

    info();
  }, []);

  // Update timezone whenever dates are changed
  const handleDateChange = (date) => {
    if (date && date.length === 2) {
      setStartDate(date[0]);
      setEndDate(date[1]);
      // Update timezone when user selects new dates
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setTimezone(userTimezone);
    }
  };

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">Hello {userName}!</h4>
              <p className="text-muted mb-0">Here is your insight.</p>
            </div>
            <div className="mt-3 mt-lg-0">
              <form action="#">
                <Row className="g-3 mb-0 align-items-center">
                  <div className="col-sm-auto">
                    <div className="input-group">
                      <StyledFilterWrapper>
                        <ReactSelect
                          {...reactSelectStyling}
                          options={siteList}
                          value={selectedSiteOptions}
                          placeholder="Select Sites"
                          isSearchable={true}
                          isClearable={true}
                          name={"sites"}
                          isMulti={true}
                          onChange={(selectedOptions) =>
                            setSelectedSiteIds(
                              selectedOptions ? selectedOptions.map((option) => option.value) : []
                            )
                          }
                        />
                      </StyledFilterWrapper>
                    </div>
                  </div>
                  <div style={{ width: "300px", maxWidth: "400px" }}>
                    <Flatpickr
                      options={{
                        mode: "range",
                        enableTime: true,
                        dateFormat: "Y-m-d H:i",
                        defaultDate: [startDate, endDate],
                      }}
                      className="form-control w-100 bg-white"
                      value={[startDate, endDate]}
                      onChange={handleDateChange}
                    />
                  
                  </div>
                  <div className="col-sm-auto">
                    <Button
                      style={{ background: "#ce9558" }}
                      onClick={getDailyReport}
                    >
                      <i className=""></i> Filter
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Section;

const StyledFilterWrapper = styled.div`
  min-width: 200px;
  // flex: 1;
`;
